module.exports = __webpack_public_path__ + "static/media/sample.4d4faf28.xlsx";